import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

const HelpVideoView = (props) => {   

    const MEDIA_BASE_URL = process.env.REACT_APP_MEDIA_URL;

    const urlAgil = `${MEDIA_BASE_URL}/Agil-${props.info.url}.mp4`;
    const urlTradicional = `${MEDIA_BASE_URL}/Tradicional-${props.info.url}.mp4`;
    const urlGeneralidades = `${MEDIA_BASE_URL}/Generalidades-${props.info.url}.mp4`;
  
    return(
    <>
    {(props.info.type === "Tradicional") &&
      <div className="text-center">
         <div className="embed-responsive embed-responsive-16by9">
          <video className="embed-responsive-item" 
            src={urlTradicional} 
            controls 
            allowFullScreen
            autoPlay 
            controlsList="nodownload">
          </video>
        </div>
      </div>
    }
    {(props.info.type === "Agil") &&
      <div className="text-center">
        <div className="embed-responsive embed-responsive-16by9">
          <video className="embed-responsive-item" 
            src ={urlAgil}
            controls 
            allowFullScreen
            autoPlay 
            controlsList="nodownload">
          </video>
        </div>
        <span>  </span>
      </div>
    }
    {(props.info.type === "Generalidades") &&
      <div className="text-center">
         <div className="embed-responsive embed-responsive-16by9">
          <video className="embed-responsive-item" 
            src={urlGeneralidades}
            controls 
            allowFullScreen
            autoPlay 
            controlsList="nodownload">
          </video>
        </div>
      </div>
    }

    </>
);
};

export default HelpVideoView;